import gxxImg from "../../../Assets/Images/VT323.png";
import gxxcom from "../../../Assets/Images/gxxcom.png";
import logo from "../../../Assets/Images/logo2.png";
const billBoardData = [
  {
    name: "abc designs",
    image: gxxImg,
  },
  {
    name: "anonymous shop",
    image: gxxcom,
  },
  {
    name: "delicious foods",
    image: logo,
  },
];
export default billBoardData;
